import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'

export enum LuckySlotZIndex {
  loadingPage = 9999,
  smallWinAmis = 3,
  bigWinAmis = 3,
  bonusWinAmis = 1000,
  guidePage = 5000,
  taskPop = 5000,
}

export enum StatusEnum {
  未完成 = 0,
  完成未领取 = 1,
  完成已领取 = 2,
}
export enum freePlayActionTypeEnum {
  非目标用户 = 0,
  命中奖励 = 1,
  免费任务有效 = 2,
}
export enum freePlayGuideStepEnum {
  freespin引导 = 1,
  freespin引导状态扭转中 = '1-1',
  freespin中 = 2,
  自动调整线数 = 3,
  spin = 4,
  none = 0,
}

export enum subPageName {
  排行榜 = 'RankModal',
  规则页 = 'RuleModal',
  记录页 = 'RecordModal',
}

export enum BulletMtypeEnum {
  common = 1,
  freespin = 2,
  bonus = 3,
  jackpot = 4,
}

export enum ElementTypeEnum {
  common = 1,
  wild = 2,
  scatter = 3,
  bonus = 4,
  jackpot = 5,
}
export enum LineWinTypeEnum {
  big = 'big',
  mega = 'mega',
  ecip = 'ecip',
  jackpot = 'jackpot',
  bonusret = 'bonusret',
}
export enum BetResultStatusEnum { // 下注结果
  notEnough = 2,
  changeLineOrBet = 3,
  success = 1,
}

export enum LuckySlotSoundEnum {
  stop = `${HostMaps.auto.img01}/download/file?obj=mefile/95/ac/fb7d-1bfb-11ee-ae81-00163e04069f` as any,
  goGame = `${HostMaps.auto.img01}/download/file?obj=mefile/9e/71/e6d1-1bfb-11ee-b0ae-00163e0442bb` as any,
  line = `${HostMaps.auto.img01}/download/file?obj=mefile/a6/be/e879-1bfb-11ee-ae81-00163e04069f` as any,
  lineStop = `${HostMaps.auto.img01}/download/file?obj=mefile/d7/50/1020-1bfb-11ee-ae81-00163e04069f` as any,
  spin = `${HostMaps.auto.img01}/download/file?obj=mefile/b1/7d/2242-1bfb-11ee-b0ae-00163e0442bb` as any,
  bigWin = `${HostMaps.auto.img01}/download/file?obj=mefile/b7/fb/c299-1bfb-11ee-ae81-00163e04069f` as any,
  megaWin = `${HostMaps.auto.img01}/download/file?obj=mefile/c8/e6/ec63-1bfb-11ee-ae81-00163e04069f` as any,
  superWin = `${HostMaps.auto.img01}/download/file?obj=mefile/cf/f7/7266-1bfb-11ee-ae81-00163e04069f` as any,
  freeSpin = `${HostMaps.auto.img01}/download/file?obj=mefile/c1/97/aa19-1bfb-11ee-ae81-00163e04069f` as any,
  zhuixian = `${HostMaps.auto.img01}/download/file?obj=mefile/61/dc/845a-26db-11ee-ae81-00163e04069f` as any,
  zhuixianfast = `${HostMaps.auto.img01}/download/file?obj=mefile/10/e8/cd17-26dd-11ee-b0ae-00163e0442bb` as any,
  bonusJackpotWin = `${HostMaps.auto.img01}/download/file?obj=mefile/b9/34/d33b-1bfd-11ee-ae81-00163e04069f` as any,
}
export enum LuckySlotSoundTypeEnum {
  '停止' = 'stop',
  '进小游戏' = 'goGame',
  '连线' = 'line',
  '每列停' = 'lineStop',
  '抽奖' = 'spin',
  '大奖' = 'bigWin',
  '中奖' = 'megaWin',
  '超级大奖' = 'superWin',
  '免费抽' = 'freeSpin',
  '追线' = 'zhuixian',
  '追线快速' = 'zhuixianfast',
  'bonusJackpotWin' = 'bonusJackpotWin',
}

export enum BonusLogEnum {
  宝箱动画展示页 = 1,
  选择宝箱页 = 2,
  宝箱结果页 = 3,
  主动点击宝箱动画展示页的按钮 = 1,
  主动点击选择宝箱页中的宝箱 = 2,
}

export enum SlotKingStateEnum {
  // 2:冠军公布;0:蓄力中;1:抢夺中
  energy = 0,
  snatch = 1,
  resultShow = 2,
}
